import React from 'react';
import Skeleton from 'react-loading-skeleton';
import dateService from '../../../services/date.service';
import { formatAmount } from '../../../utils/number-utils';
import './dashboard-page.part.summary.scss';

interface DashboardPagePartSummaryProps {
  transactionsNo: number;
  amount: number;
  commission: number;
  isLoading: boolean;
}

const DashboardPagePartSummary: React.FC<DashboardPagePartSummaryProps> = ({
  transactionsNo,
  amount,
  isLoading = false,
}) => {
  return (
    <div className='dashboard-page-part-summary flex-column flex-gap-10 flex-align-center-center'>
      <div className='description'>
        Total Transactions:{' '}
        <span className='value'>
          {isLoading ? <Skeleton width={50} highlightColor="#218579" /> : transactionsNo}
        </span>
      </div>
      <div className='description'>
        Total Amount:{' '}
        <span className='value'>
          {isLoading ? <Skeleton width={80} highlightColor="#218579" /> : `$${formatAmount(amount)}`}
        </span>
      </div>
      <div className='description'>
        Data for{' '}
        <span className='value'>
          {dateService.currentDate()}
        </span>
      </div>
    </div>
  );
};

export default DashboardPagePartSummary;
